import type { TaskCaseRow } from '../data/tasks';
import { isOnHoldTaskStatus } from './taskCaseDetailMappers';

export function onHoldRowClass(status: string | undefined): string {
  return status && isOnHoldTaskStatus(status) ? 'nr-hold' : '';
}

/** Tasks & Cases list — combines On Hold with notification / sub-task / forwarded highlights. */
export function taskCaseRowHighlightClass(r: TaskCaseRow): string {
  const classes: string[] = [];
  const hold = onHoldRowClass(r.status);
  if (hold) classes.push(hold);
  if (r.highlightVariant === 'subtask') classes.push('nr-sub');
  else if (r.highlightVariant === 'forwarded') classes.push('nr-fwd');
  else if (r.hasNewNotification) classes.push('nr');
  return classes.join(' ');
}

/** Task list screens with optional new-notification highlight. */
export function notificationRowHighlightClass(r: {
  status?: string;
  hasNewNotification?: boolean;
}): string {
  const classes: string[] = [];
  const hold = onHoldRowClass(r.status);
  if (hold) classes.push(hold);
  else if (r.hasNewNotification) classes.push('nr');
  return classes.join(' ');
}
